import { CopilotDocumentIngestResult, CopilotDocumentIngestStatus } from 'models/copilot/copilotDocumentIngest';
import AppError from 'utils/appError';

const isStaleLibraryDocumentMessage = (message: string | undefined): boolean => {
  const normalized = message?.toLowerCase() ?? '';

  return normalized.includes('library document not found') || normalized.includes('library page not found');
};

export const isStaleLibraryDocumentIngestResult = (result: CopilotDocumentIngestResult | undefined): boolean => {
  return result?.status === CopilotDocumentIngestStatus.NotFound && isStaleLibraryDocumentMessage(result.message);
};

export const isStaleLibraryDocumentError = (err: unknown): boolean => {
  const error = err instanceof AppError ? err : AppError.fromApiError(err);

  return isStaleLibraryDocumentMessage(error.message) || isStaleLibraryDocumentMessage(error.data?.message);
};
